import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getSurchargesNoSurcharges as getSurchargesNoSurchargesApi,
    getNoNonShipmentSurcharges as getNoNonShipmentSurchargesApi,
    getNonShipmentSurchargesCost as getNonShipmentSurchargesCostApi,
    getSurchargesCost as getSurchargesCostApi,
    getAuditableSurchargesCost as getAuditableSurchargesCostApi,
    getComparisonSurchargesCost as getComparisonSurchargesCostApi,
    getSurchargesComparisonRecords as getSurchargesComparisonRecordsApi,
} from '../../helpers';
import { surchargesOptimizationsApiResponseSuccess, surchargesOptimizationsApiResponseError, } from './actions';
import { SurchargesOptimizationsActionTypes } from './constants';
import { surchargesComparisonRecordResponseToSurchargesComparisonRecordObject } from '../../helpers/mappers/surchargesComparisonRecord';
import { paginationHeadersResponse } from '../../helpers/mappers/pagination';
import { addToast } from '../actions';

function* getSurchargesNoSurcharges({ payload: { query } }) {
    try {
        const getSurchargesNoSurchargesResponse = yield call(getSurchargesNoSurchargesApi, query);
        yield put(surchargesOptimizationsApiResponseSuccess(SurchargesOptimizationsActionTypes.GET_SURCHARGES_NO_SURCHARGES, getSurchargesNoSurchargesResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(surchargesOptimizationsApiResponseError(SurchargesOptimizationsActionTypes.GET_SURCHARGES_NO_SURCHARGES, error));
    }
}

function* getNoNonShipmentSurcharges({ payload: { query } }) {
    try {
        const getNoNonShipmentSurchargesResponse = yield call(getNoNonShipmentSurchargesApi, query);
        yield put(surchargesOptimizationsApiResponseSuccess(SurchargesOptimizationsActionTypes.GET_NO_NON_SHIPMENT_SURCHARGES, getNoNonShipmentSurchargesResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(surchargesOptimizationsApiResponseError(SurchargesOptimizationsActionTypes.GET_NO_NON_SHIPMENT_SURCHARGES, error));
    }
}

function* getNonShipmentSurchargesCost({ payload: { query } }) {
    try {
        const getNonShipmentSurchargesCostResponse = yield call(getNonShipmentSurchargesCostApi, query);
        yield put(surchargesOptimizationsApiResponseSuccess(SurchargesOptimizationsActionTypes.GET_NON_SHIPMENT_SURCHARGES_COST, getNonShipmentSurchargesCostResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(surchargesOptimizationsApiResponseError(SurchargesOptimizationsActionTypes.GET_NON_SHIPMENT_SURCHARGES_COST, error));
    }
}

function* getSurchargesCost({ payload: { query } }) {
    try {
        const getSurchargesCostResponse = yield call(getSurchargesCostApi, query);
        yield put(surchargesOptimizationsApiResponseSuccess(SurchargesOptimizationsActionTypes.GET_SURCHARGES_COST, getSurchargesCostResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(surchargesOptimizationsApiResponseError(SurchargesOptimizationsActionTypes.GET_SURCHARGES_COST, error));
    }
}

function* getAuditableSurchargesCost({ payload: { query } }) {
    try {
        const getAuditableSurchargesCostResponse = yield call(getAuditableSurchargesCostApi, query);
        yield put(surchargesOptimizationsApiResponseSuccess(SurchargesOptimizationsActionTypes.GET_AUDITABLE_SURCHARGES_COST, getAuditableSurchargesCostResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(surchargesOptimizationsApiResponseError(SurchargesOptimizationsActionTypes.GET_AUDITABLE_SURCHARGES_COST, error));
    }
}

function* getComparisonSurchargesCost({ payload: { query } }) {
    try {
        const getComparisonSurchargesCostResponse = yield call(getComparisonSurchargesCostApi, query);
        yield put(surchargesOptimizationsApiResponseSuccess(SurchargesOptimizationsActionTypes.GET_COMPARISON_SURCHARGES_COST, getComparisonSurchargesCostResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(surchargesOptimizationsApiResponseError(SurchargesOptimizationsActionTypes.GET_COMPARISON_SURCHARGES_COST, error));
    }
}

function* getSurchargesComparisonRecords({ payload: { query } }) {
    try {
        const getAllSurchargesComparisonRecordsResponse = yield call(getSurchargesComparisonRecordsApi, query);
        const surchargesComparisonRecords = getAllSurchargesComparisonRecordsResponse.data.map((surchargesComparisonRecordResponse) =>
            surchargesComparisonRecordResponseToSurchargesComparisonRecordObject(surchargesComparisonRecordResponse)
        );
        const pagination = { ...paginationHeadersResponse(getAllSurchargesComparisonRecordsResponse.headers), ...query };
        yield put(surchargesOptimizationsApiResponseSuccess(SurchargesOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_RECORDS, { surchargesComparisonRecords, pagination }));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(surchargesOptimizationsApiResponseError(SurchargesOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_RECORDS, error));
    }
}

export function* watchGetSurchargesNoSurcharges(): any {
    yield takeLatest(SurchargesOptimizationsActionTypes.GET_SURCHARGES_NO_SURCHARGES, getSurchargesNoSurcharges);
}

export function* watchGetNoNonShipmentSurcharges(): any {
    yield takeLatest(SurchargesOptimizationsActionTypes.GET_NO_NON_SHIPMENT_SURCHARGES, getNoNonShipmentSurcharges);
}

export function* watchGetNonShipmentSurchargesCost(): any {
    yield takeLatest(SurchargesOptimizationsActionTypes.GET_NON_SHIPMENT_SURCHARGES_COST, getNonShipmentSurchargesCost);
}

export function* watchGetSurchargesCost(): any {
    yield takeLatest(SurchargesOptimizationsActionTypes.GET_SURCHARGES_COST, getSurchargesCost);
}

export function* watchGetAuditableSurchargesCost(): any {
    yield takeLatest(SurchargesOptimizationsActionTypes.GET_AUDITABLE_SURCHARGES_COST, getAuditableSurchargesCost);
}

export function* watchGetComparisonSurchargesCost(): any {
    yield takeLatest(SurchargesOptimizationsActionTypes.GET_COMPARISON_SURCHARGES_COST, getComparisonSurchargesCost);
}

export function* watchGetSurchargesComparisonRecords(): any {
    yield takeLatest(SurchargesOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_RECORDS, getSurchargesComparisonRecords);
}

function* surchargesOptimizationsSaga() {
    yield all([
        fork(watchGetSurchargesNoSurcharges),
        fork(watchGetNoNonShipmentSurcharges),
        fork(watchGetNonShipmentSurchargesCost),
        fork(watchGetSurchargesCost),
        fork(watchGetAuditableSurchargesCost),
        fork(watchGetComparisonSurchargesCost),
        fork(watchGetSurchargesComparisonRecords),
    ]);
}

export default surchargesOptimizationsSaga;
